import { parseNumber, roundDecimal } from '../utils/display'
import Ratio from './Ratio'

export type DataParamProps = {
  latest: number
  oldest?: number
  qty: string
}

function DataParam({ latest, oldest = undefined, qty }: DataParamProps) {
  if (oldest === undefined) {
    return (
      <div className='text-2xl text-black-900 font-medium'>
        <span>{parseNumber(latest >= 1 ? latest : roundDecimal(latest, 2))}</span>
        <span className='pl-2 text-sm font-medium'>{qty}</span>
      </div>
    )
  }

  return (
    <div className='flex flex-col items-center'>
      <div className='text-2xl text-black-900 font-medium'>
        <span>{parseNumber(latest >= 1 ? latest : roundDecimal(latest, 2))}</span>
        <span className='pl-2 text-sm font-medium'>{qty}</span>
      </div>
      <div className='flex'>
        <Ratio current={latest} prev={oldest} />
        <div className='text-sm mx-1 text-black-900 font-medium'>{`(${parseNumber(oldest)})`}</div>
      </div>
    </div>
  )
}

DataParam.defaultProps = {
  oldest: undefined,
}

export default DataParam
